module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel04_770_280_vi-33bb201168015bcffe57da5d40499e40.jpg";